import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";

class PostListinCategoryForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    colorTheme: 1,
                    listSize:5
                },
                validated: true
            })
        }
    }

    @autobind
    handleChangeColorTheme(item) {
        const { data, onChange } = this.props
        onChange(update(data, {
            setting: {
                colorTheme: {
                    $set: item.value
                }
            },
            validated: {
                $set: true
            }
        }))
    }

    @autobind
    handleChangeListSize(item) {
        const { data, onChange } = this.props
        onChange(update(data, {
            setting: {
                listSize: {
                    $set: item.value
                }
            },
            validated: {
                $set: true
            }
        }))
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin38">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        카테고리의 다른 글은

                        <TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'회색', value:'1' },
                            { label:'빨간색', value:'2' },
                            { label:'파란색', value:'3' },
                            { label:'초록색', value:'4' },
                            { label:'보라색', value:'5' },
                        ]} selected={data.setting.colorTheme} onSelect={this.handleChangeColorTheme}/>
                        으로 표시하고

                        <TSelectForm className="opt_set opt_plugin2" items={[
                            { label:'3', value:'3' },
                            { label:'4', value:'4' },
                            { label:'5', value:'5' },
                            { label:'6', value:'6' },
                            { label:'7', value:'7' },
                            { label:'8', value:'8' },
                        ]} selected={data.setting.listSize} onSelect={this.handleChangeListSize}/>
                        개씩 표시합니다.
                    </div>
                    <span className="screen_out">색상 미리보기</span>
                    <p className="box_plugin">
                        {this.renderPreview()}
                    </p>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }

    renderPreview() {
        const { data } = this.props

        switch(data.setting.colorTheme) {
            case '2':
                return <span className="img_cate img_cate2">빨간색</span>
            case '3':
                return <span className="img_cate img_cate3">파란색</span>
            case '4':
                return <span className="img_cate img_cate4">초록색</span>
            case '5':
                return <span className="img_cate img_cate5">보라색</span>
            default:
                return <span className="img_cate">회색</span>
        }
    }
}

PostListinCategoryForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default PostListinCategoryForm
